import { render, staticRenderFns } from "./GenericDatatable.vue?vue&type=template&id=7b9f7ee4&"
import script from "./GenericDatatable.vue?vue&type=script&lang=js&"
export * from "./GenericDatatable.vue?vue&type=script&lang=js&"
import style0 from "./GenericDatatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VDataTable})
